const unsortedTags = [
  'digital media',
  'traditional media',
  'DIMONscapes',
  'ARTIFACTS I',
  'ARTIFACTS II',
  'oil paintings',
  'WALL STREET BOYS',
  'GUNS',
  'icons',
  'INFORMATION PAINTINGS',
  'INFORMATION DRAWINGS',
  'iPAD paintings',
  'digital paintings',
  'digital nudes',
  'SAD WOMEN',
  'spiritual art',
  'drawings',
  'mixed media',
  'video',
  'portraits',
  'digital portraits',
  'florals',
  'TV Paintings',
  'digital drawings',
  'other artists',
  'Flash Shockwave Animation',
  'documentation',
  'DUMP INC.',
  'CARTOONS',
  'PENCILS',
  'PERSONAL ADVERTISEMENTS',
  'parties',
];

const tags = [...new Set(unsortedTags.sort((a, b) => {
  let A = a.toUpperCase(); 
  let B = b.toUpperCase(); 
  if (A < B) {
    return -1;
  }
  if (A > B) {
    return 1;
  }
  return 0;
}))];
export { tags };